// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__1pGNu","navText":"Navbar_navText__uAJG_","navLogo":"Navbar_navLogo__1Mi-o","imgLogo":"Navbar_imgLogo__24_LL"};